import { createSelector } from "reselect";
import _ from "lodash";

const createSelectors = (parentReducer) => {
    return new (class {
        getUsers = (store) => {
            const reducer = store["MainReducer"];
            return reducer.users;
        };
        getGroups = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["MessengerWidget_reducer"];
            return reducer.groups;
        };
        selectAllAreas = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["MessengerWidget_reducer"];
            return reducer.areas;
        };
        selectAllDepartments = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["MessengerWidget_reducer"];
            return reducer.departments;
        };
        selectProfile = store => {
            const reducer = store["UserProfile_reducer"];
            let userInfo = reducer.user;
            return userInfo.profile;
        };
        selectDept = createSelector (
            [this.selectProfile],
            
            (profile = false) => {
                if(profile)
                {
                    return profile.departments
                }
                else return null
            }
        )
        selectAreas = createSelector (
            [this.selectProfile],
            (profile = false) => {
                if(profile)
                {
                    return profile.areas
                }
                else return null
            }
        )

        selectRegisteredUsers = createSelector([
                this.getUsers,
                this.selectAllAreas, 
                this.selectAllDepartments, 
                this.selectAreas, 
                this.selectDept,
                this.selectProfile
            ], (
                users,
                allAr = false, 
                allDept = false,
                userAreas = false, 
                userDepts = false,
                profile = false) => {
            if (
                users === false ||
                typeof users === "undefined" ||
                users === null
            ) {
                return [];
            }

             //get users belonging to logged in user areas & depts    
             let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
             let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
              
             if(userAreas === false){
                  userAreas = allAreas
             }
             if(userDepts === false){
                  userDepts = allDepartments
             }
             let validationArea = []
             let validationDept = []
             let totalUsers = [];
             if(users){
                 totalUsers = _.compact(
                    Object.keys(users).map(e => {
                        let deleted =
                            _.get(users[e], "profile.deleted") || false;
                        let areas = 
                            _.get(users[e], "profile.areas") || null
                        let departments = 
                            _.get(users[e], "profile.departments") || null 

                        if(areas === null ){
                            validationArea = _.intersection(allAreas,userAreas)
                        }else{
                            validationArea = _.intersection(areas,userAreas)
                        }

                        if(departments === null){
                            validationDept = _.intersection(allDepartments,userDepts)
                        }else {
                            validationDept = _.intersection(departments,userDepts)
                        } 

                        if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                            
                            return users[e];
                                
                        } else return null;
                    })
                );
             }
                let regUsers = _.compact(
                Object.keys(totalUsers).map((e) => {
                    if (_.get(totalUsers[e], "profile.deleted") !== true)
                        return {
                            name: `${_.get(
                                totalUsers[e],
                                "profile.first_name"
                            )} ${_.get(totalUsers[e], "profile.last_name")}`,
                            uid: _.get(totalUsers[e], "profile.uid"),
                        };
                    else return null;
                })
            );
            regUsers = regUsers.filter((e) => {
                if (e.deleted !== true) {
                    return true;
                } else {
                    return false;
                }
            });
            return regUsers.sort((a, b) => a.name.localeCompare(b.name));
        });
        selectGroup = createSelector([this.getGroups], (groups) => {
            if (
                groups === false ||
                typeof groups === "undefined" ||
                groups === null
            ) {
                return [];
            }

            let regGroups = Object.keys(groups).map((e) => {
                return groups[e];
            });
            return _.orderBy(regGroups, "most_recent_message.timestamp", [
                "desc",
            ]);
        });
    })();
};

export default createSelectors;
